import {
  JourneyMapDraft,
  JourneyMapDraftItem, JourneyMapDraftLink,
  JourneyMapSectionDelimiterDraft,
} from '../../types/journeyMap';
import { normalizeLinkDefaults } from './builderNormailization';


export const makeTempId = (prefix: string) =>
  `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const createInitialDraft = (): JourneyMapDraft => ({
  tempId: makeTempId('journey-map'),
  name: 'Untitled Journey Map',
  slug: '',
  image_url: '',
  background_image_url: '',
  description: '',
  journey_type: null,
  owner: null,
  version: 1,
  status: 'draft',
  publication_status: 'draft',
  is_active: true,
  estimated_duration_minutes: null,
  audience_rules: {},
  metadata: {},
  available_from: null,
  available_to: null,
  items: [],
  links: [],
  pathGroups: [],
  section_delimiters: [],
  selectedItemTempId: null,
  selectedLinkTempId: null,
  selectedPathGroupTempId: null,
  isDirty: false,
  isNew: true,
});

export const createDraftItem = (partial?: Partial<JourneyMapDraftItem>): JourneyMapDraftItem => ({
  tempId: makeTempId('journey-map-item'),
  id: partial?.id,
  journey_map: partial?.journey_map,
  name: partial?.name || 'New Item 1',
  description: partial?.description || '',
  order: partial?.order ?? 1,
  item_type: partial?.item_type || 'content',
  is_required: partial?.is_required ?? true,
  estimated_duration_minutes: partial?.estimated_duration_minutes ?? null,
  content_ref_type: partial?.content_ref_type || '',
  content_ref_id: partial?.content_ref_id || '',
  provider: partial?.provider || '',
  launch_url: partial?.launch_url || '',
  completion_mode: partial?.completion_mode || 'external_sync',
  provider_config: partial?.provider_config || {},
  prerequisite_logic: partial?.prerequisite_logic || {},
  metadata: partial?.metadata || {},
  passing_score: partial?.passing_score ?? null,
  due_offset_days: partial?.due_offset_days ?? null,
  available_from: partial?.available_from || null,
  available_to: partial?.available_to || null,
  position_x: partial?.position_x ?? 240,
  position_y: partial?.position_y ?? 140,
  isNew: partial?.isNew ?? true,
  isDirty: partial?.isDirty ?? true,
  isDeleted: partial?.isDeleted ?? false,
});

export const createDraftLink = (partial?: Partial<JourneyMapDraftLink>): JourneyMapDraftLink => {
  const linkType = partial?.link_type || 'default';
  const normalized = normalizeLinkDefaults(
    linkType,
    partial?.condition_type,
    partial?.condition_config,
  );

  return {
    tempId: makeTempId('journey-map-link'),
    id: partial?.id,
    journey_map: partial?.journey_map,
    from_item: partial?.from_item,
    from_item_temp_id: partial?.from_item_temp_id ?? null,
    to_item: partial?.to_item,
    to_item_temp_id: partial?.to_item_temp_id ?? null,
    label: partial?.label || '',
    link_type: linkType,
    condition_type: normalized.condition_type,
    condition_config: normalized.condition_config,
    priority: partial?.priority ?? 0,
    is_active: partial?.is_active ?? true,
    source_handle: partial?.source_handle ?? null,
    target_handle: partial?.target_handle ?? null,
    edge_shape: partial?.edge_shape ?? 'smoothstep',
    edge_thickness: partial?.edge_thickness ?? null,
    edge_dash_style: partial?.edge_dash_style ?? null,
    edge_animated: partial?.edge_animated ?? null,
    isNew: partial?.isNew ?? true,
    isDirty: partial?.isDirty ?? true,
    isDeleted: partial?.isDeleted ?? false,
  };
};

export function createDraftSectionDelimiter(
  partial: Partial<JourneyMapSectionDelimiterDraft> = {},
): JourneyMapSectionDelimiterDraft {
  return {
    id: partial.id,
    tempId: partial.tempId || `delimiter-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    x: partial.x ?? 0,
    y: partial.y ?? 0,
    orientation: partial.orientation || 'horizontal',
    style: partial.style || 'solid',
    color: partial.color || 'neutral',
    label: partial.label || '',
    isDirty: partial.isDirty ?? true,
    isDeleted: partial.isDeleted ?? false,
  };
}